import { FormModel } from '../core/form-model.class';
import { FrontCreateAgencyDto } from './create-agency.dto';

export class AgencyFormModel extends FormModel(FrontCreateAgencyDto) {
  public labels: any = {
    label: 'Libellé',
    code: 'Code',
  };
}
